export default [
  {
    path: '/agent',
    name: 'agent',
    component: () => import('@/views/menu/agent/agent.vue'),
    meta: {
      pageTitle: 'مدیریت ترخیص‌کاران',
      action: 'show',
      resource: 'AgentManager',
    },
  },
]
